import { Outlet } from "react-router-dom";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Zoom from "@mui/material/Zoom";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import HotTopics from '../components/HotTopics';
import useShowHotTopics from '../hooks/useShowHotTopics';

// 監聽路由變化，強制回頂部
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function ScrollTopButton() {
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 200 });

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          position: "fixed",
          bottom: 32,
          right: 32,
          zIndex: 1300,
        }}
      >
        <Fab
          size="small"
          aria-label="scroll back to top"
          sx={{
            background: "linear-gradient(145deg, #c0c0c0, #f5f5f5)",
            color: "#222",
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            border: "1px solid #aaa",
            "&:hover": {
              background: "linear-gradient(145deg, #d9d9d9, #ffffff)",
            },
          }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Box>
    </Zoom>
  );
}

export default function RootLayout() {
  const showHot = useShowHotTopics();
  return (
    <>
      <ScrollToTop />
      <Outlet />   {/* 渲染子頁面 */}
      {showHot && <HotTopics />}
      <ScrollTopButton />
    </>
  );
}
